import React from "react";
import { Tabs, Tab, Container } from "react-bootstrap";
import Inbox from "../../../components/messages/Inbox/Inbox";
import DraftMessage from "../../../components/messages/DraftMessage/DraftMessage";
import SentMessages from "../../../components/messages/SentMessages/SentMessages";
import DesktopLayout from "../../../layouts/DesktopLayout/DesktopLayout";

const MessagesPage = () => {
  
  return (
    <DesktopLayout>
      <Container className="mt-5">
        <h1 className="text-center">Messages</h1>
        <Tabs defaultActiveKey="inbox" className="mt-4" id="messages-tabs">
          <Tab eventKey="inbox" title="Inbox">
            <div className="p-3">
              <Inbox />
            </div>
          </Tab>
          <Tab eventKey="compose" title="Compose Message">
            <div className="p-3">
              <DraftMessage />
            </div>
          </Tab>
          <Tab eventKey="sent" title="Sent Messages">
            <div className="p-3">
              <SentMessages />
            </div>
          </Tab>
        </Tabs>
      </Container>
    </DesktopLayout>
  );
};

export default MessagesPage;